// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1414":"605208d1","1536":"29a701cb","1895":"e4bf980a"}[chunkId] + ".chunk.css";
};